import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import MenuMobile from 'modules/shared/layout/menu/menu-mobile';
import useToggle from 'hooks/use-toggle';
import MenuLinkMobile from 'modules/shared/layout/menu/menu-mobile/components/menu-list-mobile/components/menu-link-mobile';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';

import './menu-item-mobile.scss';

interface MenuItemMobileProps {
    onClose: () => void;
    item: MenuInterface;
    className?: string;
    loadMenu: boolean;
    level: number;
}

const MenuItemMobile: React.FC<MenuItemMobileProps> = ({ item, onClose, className, loadMenu, level }) => {
    const [isOpenItemMenu, setIsOpenItemMenu] = useToggle();

    const onOpenItemMenu = useCallback(() => {
        setIsOpenItemMenu.setToggleState(true);
    }, [setIsOpenItemMenu]);

    const onCloseItemMenu = useCallback(() => {
        setIsOpenItemMenu.setToggleState(false);
    }, [setIsOpenItemMenu]);

    const onCloseMenu = useCallback(() => {
        onClose();
        setIsOpenItemMenu.setToggleState(false);
    }, [setIsOpenItemMenu, onClose]);

    return (
        <li className={classNames('menu-item-mobile', className)}>
            <MenuLinkMobile
                name={item[MenuKeys.name]}
                url={item.url}
                icon={loadMenu ? item[MenuKeys.icon] : ''}
                onClick={item[MenuKeys.items]?.length ? onOpenItemMenu : undefined}
                isArrow={Boolean(item[MenuKeys.items]?.length)}
            />
            {Boolean(item[MenuKeys.items]?.length) && (
                <MenuMobile
                    isOpen={isOpenItemMenu}
                    onBack={onCloseItemMenu}
                    title={item[MenuKeys.name]}
                    menuList={item[MenuKeys.items] || []}
                    url={item.url}
                    onClose={onCloseMenu}
                    level={level + 1}
                />
            )}
        </li>
    );
};

export default memo(MenuItemMobile);
